<template>
  <div class="multiselect-chips">
    <multiselect
      v-model="internalValue"
      :options="options"
      :multiple="true"
      :close-on-select="false"
      :clear-on-select="false"
      :hide-selected="false"
      :show-labels="false"
      :taggable="false"
      :track-by="trackBy"
      :label="label"
      :placeholder="placeholder"
      :searchable="true"
      :limit="1"
      :limit-text="limitText"
      class="w-100"
      @input="emitValue"
    >
      <template #option="{ option, index }">
        <div class="d-flex align-items-center justify-content-between w-100">
          <span>{{ option[label] || option }}</span>
          <font-awesome-icon
            v-if="isSelectedOption(option)"
            :icon="['fas', 'check']"
            class="option-selected-icon"
          />
        </div>
      </template>

      <template #noResult>
        <span>{{ noResultText }}</span>
      </template>

      <template #noOptions>
        <span>{{ noOptionsText }}</span>
      </template>
    </multiselect>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'MultiSelectChips',
  components: { Multiselect },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: 'Selecione...'
    },
    trackBy: {
      type: String,
      default: 'value'
    },
    label: {
      type: String,
      default: 'text'
    },
    noResultText: {
      type: String,
      default: 'Nenhum elemento encontrado.'
    },
    noOptionsText: {
      type: String,
      default: 'Nenhum dado foi retornado.'
    }
  },
  data() {
    return {
      internalValue: this.value || []
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.internalValue = newVal || [];
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    emitValue() {
      this.$emit('input', this.internalValue);
      this.$emit('change', this.internalValue);
    },
    limitText(count) {
      return `+${count}`;
    },
    isSelectedOption(option) {
      if (!this.internalValue || !this.internalValue.length) return false;
      return this.internalValue.some((item) => {
        if (this.trackBy && item && option) {
          return item[this.trackBy] === option[this.trackBy];
        }
        return item === option;
      });
    }
  }
};
</script>

<style scoped>
.multiselect-chips {
  width: 100%;
}

.option-selected-icon {
  color: #49b5ff;
}
</style>
